<template>
  <div class="card-report" :data-anima="`${payload.coin ? 'right' : 'left'}`">
    <div v-if="loading || error" class="pa-3">
      <div class="expand-horizontal">
        <b-skeleton width="50px" height="50px"></b-skeleton>
      </div>
      <div class="expand-horizontal nowrap" style="margin-top: 38px">
        <b-skeleton height="20px" width="60%"></b-skeleton>
      </div>
      <div class="expand-horizontal nowrap" style="margin-top: 5px">
        <b-skeleton height="20px" width="80%"></b-skeleton>
      </div>
    </div>
    <div v-else>
      <div class="expand-horizontal">
        <b-tooltip
          target="icon"
          :title="payload.disclaimer"
          placement="bottom"
        />
        <div id="icon" :class="`icon icon--${payload.icon_color}`">
          <img
            :src="require(`../../../assets/img/icons/${payload.icon}.svg`)"
            class="Pointer search"
          />
        </div>
        <div class="spacer"></div>
        <span class="title-percent pt-2" v-if="payload.percent">
          {{ payload.percent }}% 
        </span>
        
      </div>
      <div class="expand-horizontal nowrap">
        <Roller
          v-if="payload.coin"
          :isStatic="true"
          :text="
            `${payload.coin}${
              payload.value ? formatMoney(payload.value) : '0,00'
            }`
          "
          class="cash"
          :class="`element--${payload.icon_color}`"
          :transition="1"
        ></Roller>
        
        <Roller
          v-else
          :text="`${payload.value}`"
          :isStatic="true"
          :transition="1"
          class="cash"
          :class="`element--${payload.icon_color}`"
        ></Roller>
      </div>
      <div class="expand-horizontal nowrap">
        <span class="cash-subtitle"> {{ payload.name }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import FormatMoney from "@/mixins/money";
import Roller from "vue-roller";

export default {
  mixins: [FormatMoney],
  props: ["payload", "loading", "error"],
  components: { Roller },
};
</script>

<style scoped>
.expand-horizontal {
  display: flex;
}
.wrap {
  flex-wrap: wrap;
}
.nowrap {
  flex-wrap: nowrap;
}
.cash {
  width: 100%;
  display: flex;
  margin-top: 38px;
  color: #333;
  font-weight: bold;
  font-size: 20px;
  transition: 0.3s;
  letter-spacing: 0;
  position: relative;
}
.cash-subtitle {
  width: 100%;
  display: flex;
  margin-top: 5px;
  color: #81858e;
  font-weight: 400;
  font-size: 14px;
}
.percentage {
  position: relative;
  bottom: -6px;
}
.spacer {
  display: flex;
  width: 100%;
}
.card-report {
  border-radius: 5px;
  /* width: 270px; */
  height: 200px;
  padding: 30px 25px;
  border: 0.5px solid #e5e5e5;
  transition: 0.3s;
}

.icon {
  width: 50px;
  height: 50px;
  min-width: 50px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 5px;
  transition: 0.3s;
}
.icon img {
  max-width: 22px;
  transition: 0.3s;
}
.card-report:hover .icon img {
  transform: scale(1.1);
}

.icon--green,
.cash.element--green::after {
  background: rgba(0, 35, 99, 0.2);
}

.icon--blue,
.cash.element--blue::after {
  background: rgba(33, 51, 210, 0.05);
}
.icon--red,
.cash.element--red::after {
  background: rgba(255, 10, 68, 0.05);
}
.icon--yellow,
.cash.element--yellow::after {
  background: rgba(255, 208, 43, 0.1);
}
.icon--grey,
.cash.element--grey::after {
  background: #f7f7f7;
}
.title-percent {
  font-size: 15px;
  font-weight: 600;
  text-align: right;
  color: #81858e;
}
</style>
